import React from 'react';
import { Checkbox } from './Checkbox';

export function ValueChecklist({ options, selected, onChange, query }) {
  const q = query.trim().toLowerCase();
  const visible = q ? options.filter(o => o.value.toLowerCase().includes(q)) : options;

  const toggle = value => onChange(selected.includes(value) ? selected.filter(s => s !== value) : [...selected, value]);

  if (!visible.length) {
    return <p className="tw-px-4 tw-py-5 tw-text-center tw-text-sm tw-text-neutral-400">No matching values</p>;
  }

  return (
    <ul className="scrollbar-thin tw-max-h-60 tw-overflow-y-auto tw-px-1.5 tw-py-1">
      {visible.map(o => (
        <li key={o.value}>
          <label className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2.5 tw-rounded-md tw-px-2.5 tw-py-1.5 tw-text-sm tw-transition-colors tw-duration-100 hover:tw-bg-sand-50">
            <Checkbox checked={selected.includes(o.value)} onChange={() => toggle(o.value)} />
            <span className={`tw-flex-1 tw-truncate ${o.value.startsWith('(') ? 'tw-italic tw-text-neutral-400' : 'tw-text-neutral-900'}`}>{o.value}</span>
            <span className="tw-text-xs tw-tabular-nums tw-text-neutral-400">{o.count}</span>
          </label>
        </li>
      ))}
    </ul>
  );
}
